// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/**
 * How a note shows in the address bar: /vault/{id}/Folder/My-Note rather than ?file=Folder/My%20Note.md.
 * Markdown notes drop ".md" and spaces become dashes. That is not reversible on its own ("My-Note.md"
 * and "My Note.md" share a slug), so a slug is resolved against the vault's paths.
 */
export function noteSlug(path: string): string {
  return path
    .replace(/\.md$/i, "")
    .split("/")
    .map((segment) => segment.trim().replace(/\s+/g, "-"))
    .join("/");
}

/** The note a slug names: an exact path first (old links, files that are not Markdown), then by slug. */
export function noteFromSlug(slug: string, paths: readonly string[]): string | undefined {
  if (!slug) return undefined;
  if (paths.includes(slug)) return slug;
  if (paths.includes(`${slug}.md`)) return `${slug}.md`;
  return paths.find((p) => noteSlug(p) === slug) ?? paths.find((p) => noteSlug(p).toLowerCase() === slug.toLowerCase());
}
